import * as fs from "fs";
import * as ko from "knockout";
import * as moment from "moment"
import { RNSAPI } from "../../api";
import { Moment } from "moment";
import { MainViewModel } from "../../main";

class AppointmentDailyViewModel {
    appointments = ko.observableArray([]);
    lanes: KnockoutComputed<Array<Array<any>>>


    timeslots: KnockoutObservableArray<String> = ko.observableArray([]);
    currentDate: KnockoutObservable<Moment>;
    parentVM: any;

    start = 7;
    end = 19;

    //no extra module for leftpad ;)
    private static pad(n, width) {
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
    }

    private readonly marginInPx = 70;

    public left(lane: number) {
        const n = this.lanes().length;
        return `calc(${(100 / n) * lane}% - ${(this.marginInPx / n) * lane}px)`;
    }

    public width() {
        const n = this.lanes().length;
        return `calc(${100 / n}% - ${this.marginInPx / n}px)`;
    }

    public top(appointment: any) {
        let m = moment.utc(appointment.StartDate).local();
        let offset = m.hour() - this.start;
        offset += m.minute() / 60;
        return 100 * offset / (this.end - this.start) + "%";
    }

    public height(appointment: any) {
        let startDate = moment.utc(appointment.StartDate);
        let endDate = moment.utc(appointment.EndDate);
        let percentage = 100 * (endDate.diff(startDate, 'minutes') / 60 / (this.end - this.start));
        return `${percentage}%`;
    }

    public id(appointment: any) {
        return encodeURIComponent(appointment.Id);
    }

    //NOTE: Double Click was requested here, note there is **NO** native way of telling a double click
    //this is a crude timing solution (delta < 250ms), that does not take Position into account, but only the selected hour.
    public createAppointment = (() => {
        let oldTimeStamp: number = null;
        let oldHour: String = null;
        return (hour: String, event: Event) => {
            if (oldTimeStamp && oldHour && ((event.timeStamp - oldTimeStamp) < 250 && oldHour === hour)) {
                let startMoment = this.currentDate().clone().add(moment.duration(hour as any));
                MainViewModel.RoutingTable.showAppointmentView({ startdate: startMoment.toISOString() });
            } else {
                oldTimeStamp = event.timeStamp;
                oldHour = hour;
            }
        }
    })()

    public deleteAppointment = async (appointment: any) => {
        await RNSAPI.deleteAppointment(appointment.Id);
        this.parentVM.update();
    }

    constructor(params) {
        let labelArr = [];

        let count = (this.end - this.start) * 2

        for (let i = 0; i < count; i++) {
            let hour = AppointmentDailyViewModel.pad(Math.floor(i / 2) + this.start, 2);
            if (i % 2 == 0) {
                labelArr.push(`${hour}:00`);
            } else {
                labelArr.push(`${hour}:30`);
            }
        }

        this.timeslots(labelArr);

        this.currentDate = params.date;
        this.appointments = params.appointments;
        this.parentVM = params.vm;

        this.lanes = ko.computed(() => {
            let appointments = this.appointments().sort((a, b) => {
                let startA = moment.utc(a.StartDate);
                let startB = moment.utc(b.StartDate);

                if (startA.isBefore(startB)) return -1;
                else if (startA.isAfter(startB)) return 1;
                else return 0;
            });

            let lanes: Array<Array<any>> = [[]];

            for (let appointment of appointments) {
                let start = moment.utc(appointment.StartDate);
                let inserted = false;

                for (let lane of lanes) {
                    if (lane.length === 0 || moment(lane[lane.length - 1].EndDate).isBefore(start)) {
                        lane.push(appointment);
                        inserted = true;
                        break;
                    }
                }

                if (!inserted) {
                    lanes.push([appointment]);
                }
            }

            return lanes;
        });
    }
}

let html = fs.readFileSync(__dirname + '/daily.html', 'utf8');

ko.components.register("daily-view", {
    viewModel: AppointmentDailyViewModel,
    template: html
});
